import script from "./DialogConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./DialogConfirmation.vue?vue&type=style&index=0&id=8021bf4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8021bf4e"]])

export default __exports__